import { HttpClientModule, provideHttpClient } from '@angular/common/http';
// Angular Import
import { HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { ElbuildUiComponentslibModule } from 'elbuild-ui-componentslib';
import { AuthConfig, ElbuildUiLibModule } from 'elbuild-ui-lib-core';
import { ToastrModule } from 'ngx-toastr';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MatProgressBar } from '@angular/material/progress-bar';
import { environment } from 'src/environments/environment';


const authConfig: AuthConfig = {
    cookieprefix: 'ocarinabo' + environment.env,
    usertable: 'user',
    loginbase: 'access',
    loginpage: 'login',
    meendpoint: undefined,//'access/me',
    enablefeatures: true,
    i18napi: false,
    proxyfolder: environment.proxy,
    otherproxies: environment.externalapi ? [environment.externalapi] : undefined
};

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function appInitializerFactory(translate: TranslateService) {
    return () => {
        translate.setDefaultLang('it');
        return translate.use('it').toPromise();
    };
}

// project import
@NgModule({
    declarations: [
        AppComponent,

    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            },
            defaultLanguage: 'it'
        }),
        ElbuildUiLibModule.forRoot(authConfig),
        ElbuildUiComponentslibModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            preventDuplicates: true
        }),
        MatProgressBar,
        HttpClientModule //serve per gli interceptor della lib
    ],
    providers: [provideHttpClient(),
    {
        provide: APP_INITIALIZER,
        useFactory: appInitializerFactory,
        deps: [TranslateService],
        multi: true
    }
    ],

    bootstrap: [AppComponent]
})
export class AppModule { }
